import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, Tag, Briefcase, Users, Package, Layers, FileText, Radio, ClipboardList } from "lucide-react";
import { api } from "@/lib/api";

const TILES = [
  { key: "com_clients", label: "Clientes", to: "/admin/comercial/clientes", Icon: Building2 },
  { key: "com_brands", label: "Marcas", to: "/admin/comercial/marcas", Icon: Tag },
  { key: "com_agencies", label: "Agencias", to: "/admin/comercial/agencias", Icon: Briefcase },
  { key: "com_contacts", label: "Contactos", to: "/admin/comercial/contactos", Icon: Users },
  { key: "com_products", label: "Productos comerciales", to: "/admin/comercial/productos-com", Icon: Package },
  { key: "com_packages", label: "Paquetes", to: "/admin/comercial/paquetes", Icon: Layers },
  { key: "com_talents", label: "Talentos comerciales", to: "/admin/comercial/talentos", Icon: Users },
  { key: "programs", label: "Programas streaming", to: "/admin/comercial/programas", Icon: Radio },
  { key: "proposals", label: "Propuestas", to: "/admin/proposals", Icon: FileText },
  { key: "execution_orders", label: "Órdenes de ejecución", to: "/admin/comercial/ordenes", Icon: ClipboardList },
];

export default function CommercialDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/com/dashboard").then(setData).catch(() => setData({ counts: {}, proposals_by_status: {} })); }, []);

  return (
    <div data-testid="commercial-dashboard">
      <div className="mb-8">
        <h1 className="font-display text-4xl font-black tracking-tighter mb-1">Dashboard Comercial</h1>
        <p className="text-sm text-muted-foreground">Centro de control de toda la operación comercial · clientes, propuestas, campañas y ejecución.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-10">
        {TILES.map((t) => {
          const count = data?.counts?.[t.key] ?? "—";
          return (
            <Link key={t.key} to={t.to} className="border border-border rounded-sm p-5 bg-background hover:border-primary transition-colors group" data-testid={`tile-${t.key}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">{t.label}</span>
                <t.Icon className="w-4 h-4 text-primary group-hover:scale-110 transition-transform" />
              </div>
              <div className="font-display text-3xl font-black tracking-tighter">{count}</div>
            </Link>
          );
        })}
      </div>

      <div className="grid lg:grid-cols-2 gap-5">
        <div className="border border-border rounded-sm p-6">
          <h3 className="font-display font-bold text-lg mb-4">Propuestas por estado</h3>
          {data && Object.keys(data.proposals_by_status || {}).length > 0 ? (
            <ul className="space-y-2">
              {Object.entries(data.proposals_by_status).map(([k, v]) => (
                <li key={k} className="flex justify-between text-sm border-b border-border pb-2">
                  <span className="capitalize">{k}</span>
                  <span className="font-bold">{v}</span>
                </li>
              ))}
            </ul>
          ) : <p className="text-sm text-muted-foreground">Sin propuestas todavía.</p>}
        </div>
        <div className="border border-border rounded-sm p-6">
          <h3 className="font-display font-bold text-lg mb-4">Próximas etapas (F3+)</h3>
          <p className="text-sm text-muted-foreground">El workflow comercial, kanban de pipeline, campañas, cobranza y reportes se desarrollan en las próximas fases. Por ahora podés gestionar clientes, marcas, agencias, contactos, productos, paquetes, programas, talentos y propuestas conectadas.</p>
        </div>
      </div>
    </div>
  );
}
